import React from 'react';
import { Controller } from 'react-hook-form';
import useFilterWidgetFormContext from '../../../../../utils/useFilterWidgetFormContext';
import OperandTextInput from './OperandTextInput';
import BetweenFields from '../../../../../../Form/BetweenFields';
import { IPredicateFormFieldPath } from '../../../../../types';
import { getPredicateFormFieldPath } from '../../../../../utils/formPath';
import { getFieldValueKey } from '../../../../../../../utils/analytics/events/filter/utils';

interface IProps {
  formPath: IPredicateFormFieldPath;
  placeholder: string;
}

const OperandValuesBetween = ({ formPath, placeholder }: IProps) => {
  const { control } = useFilterWidgetFormContext();
  const fieldPath = getPredicateFormFieldPath(formPath);

  return (
    <BetweenFields>
      <Controller
        name={`${fieldPath}.operand.fromOperand`}
        control={control}
        render={({ field: { value, onChange }, fieldState }) => (
          <OperandTextInput
            value={value ? getFieldValueKey(value) : ''}
            onChange={onChange}
            placeholder={placeholder}
            autoFocus={!value}
            hasError={Boolean(fieldState.error)}
          />
        )}
      />
      <Controller
        name={`${fieldPath}.operand.toOperand`}
        control={control}
        render={({ field: { value, onChange }, fieldState }) => (
          <OperandTextInput
            value={value ? getFieldValueKey(value) : ''}
            onChange={onChange}
            placeholder={placeholder}
            hasError={Boolean(fieldState.error)}
          />
        )}
      />
    </BetweenFields>
  );
};

export default OperandValuesBetween;
